<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between text-white" style="padding: 32px 0;">
            <div class="d-flex align-items-center">
              <div class="header-icon-wrap mr-3">
                <i class="fe fe-database" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">Admin DB Query</h4>
                <small style="opacity: .8;">Ad-hoc table query builder</small>
              </div>
            </div>
            <button class="btn btn-light btn-sm" style="border-radius: 8px; font-weight: 600;" @click="getClients">
              <i class="fe fe-refresh-cw mr-1"></i> Refresh
            </button>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <SearchUser />

        <!-- Quick Links -->
        <div class="card action-card shadow mb-4">
          <div class="card-body py-3 px-4 d-flex flex-wrap align-items-center" style="gap: 8px;">
            <button class="btn btn-sm btn-outline-secondary" @click="firstshow = true">Add First Param</button>
            <button class="btn btn-sm btn-outline-secondary" @click="secondshow = true">Add Second Param</button>
            <button class="btn btn-sm btn-outline-secondary" @click="thirdshow = true">Add Third Param</button>
            <a href="/duplicate-id-card">
              <button class="btn btn-sm btn-outline-dark">DB Filter</button>
            </a>
            <a href="/duplicate">
              <button class="btn btn-sm btn-outline-dark">Duplicate Principal</button>
            </a>
            <a href="/duplicate-dependent">
              <button class="btn btn-sm btn-outline-dark">Duplicate Dependent</button>
            </a>
          </div>
        </div>

        <!-- Query Builder -->
        <div class="card table-card shadow mb-4">
          <div class="form-card-header">
            <div class="section-number"><i class="fe fe-sliders" style="font-size:13px;"></i></div>
            <div>
              <p class="mb-0 text-white font-weight-bold" style="font-size:.95rem;">Query Builder</p>
              <small style="color:rgba(255,255,255,.7);">Select a table and define query parameters</small>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-2">
                <label class="info-label d-block mb-1"><i class="fe fe-map-pin mr-1"></i>Per Row</label>
                <select class="form-control" v-model="paginate">
                  <option value="20" selected>20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6">
                <label class="info-label d-block mb-1"><i class="fe fe-table mr-1"></i> Select Table: {{ table }}</label>
                <select
                  class="form-control"
                  v-model="table"
                  @change="getColumns($event)"
                >
                  <option v-for="table in tables" v-bind:key="table.id">
                    {{ table.Tables_in_hip }}
                  </option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-hash mr-1"></i>Order By</label>
                <select class="form-control" v-model="order_by">
                  <option v-for="col in columns" v-bind:key="col" :value="col">
                    {{ col }}
                  </option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1">
                  <i class="fe fe-arrow-up"></i><i class="fe fe-arrow-down mr-1"></i>Order By Type: {{ order_by_type }}
                </label>
                <select class="form-control" v-model="order_by_type">
                  <option value="asc">ASC</option>
                  <option value="desc">DESC</option>
                </select>
              </div>
            </div>

            <div class="row" v-show="firstshow">
              <div class="col-md-12">
                <p class="font-weight-bold text-secondary small text-uppercase mt-2">First Column Params</p>
              </div>
              <div class="form-group col-md-4">
                <label class="info-label d-block mb-1"><i class="fe fe-map-pin mr-1"></i> Where Column 1</label>
                <select class="form-control" v-model="first_db_column">
                  <option v-for="col in columns" v-bind:key="col" :value="col">
                    {{ col }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label class="info-label d-block mb-1"><i class="fe fe-map-pin mr-1"></i>Query Operator</label>
                <select class="form-control" v-model="first_query_operator">
                  <option value="=">=</option>
                  <option value="!=">!=</option>
                  <option value=">">Greater than (&gt;)</option>
                  <option value="<">Less than</option>
                  <option value=">=">Greater than or Equals (&gt;=)</option>
                  <option value="<=">Less than or Equals</option>
                </select>
              </div>

              <div class="form-group col-md-4">
                <label class="info-label d-block mb-1">Column 1 Param</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="first_param"
                  placeholder="Put Param Here"
                />
              </div>
            </div>

            <div class="row" v-show="secondshow">
              <div class="col-md-12">
                <p class="font-weight-bold text-secondary small text-uppercase mt-2">Second Column Params</p>
              </div>
              <div class="form-group col-md-4">
                <label class="info-label d-block mb-1"><i class="fe fe-map-pin mr-1"></i> Where Column 2</label>
                <select class="form-control" v-model="second_db_column">
                  <option v-for="col in columns" v-bind:key="col" :value="col">
                    {{ col }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label class="info-label d-block mb-1"><i class="fe fe-map-pin mr-1"></i>Query Operator</label>
                <select class="form-control" v-model="second_query_operator">
                  <option value="=">=</option>
                  <option value="!=">!=</option>
                  <option value=">">Greater than (&gt;)</option>
                  <option value="<">Less than</option>
                  <option value=">=">Greater than or Equals (&gt;=)</option>
                  <option value="<=">Less than or Equals</option>
                </select>
              </div>

              <div class="form-group col-md-4">
                <label class="info-label d-block mb-1">Column 2 Param</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="second_param"
                  placeholder="Put Param Here"
                />
              </div>
            </div>

            <div class="row" v-show="thirdshow">
              <div class="col-md-12">
                <p class="font-weight-bold text-secondary small text-uppercase mt-2">Third Column Params</p>
              </div>
              <div class="form-group col-md-4">
                <label class="info-label d-block mb-1"><i class="fe fe-map-pin mr-1"></i> Where Column 3</label>
                <select class="form-control" v-model="third_db_column">
                  <option v-for="col in columns" v-bind:key="col" :value="col">
                    {{ col }}
                  </option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label class="info-label d-block mb-1"><i class="fe fe-map-pin mr-1"></i>Query Operator</label>
                <select class="form-control" v-model="third_query_operator">
                  <option value="=">=</option>
                  <option value="!=">!=</option>
                  <option value=">">Greater than (&gt;)</option>
                  <option value="<">Less than</option>
                  <option value=">=">Greater than or Equals (&gt;=)</option>
                  <option value="<=">Less than or Equals</option>
                </select>
              </div>

              <div class="form-group col-md-4">
                <label class="info-label d-block mb-1">Column 3 Param</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="third_param"
                  placeholder="Put Param Here"
                />
              </div>
            </div>

            <div class="d-flex" style="gap: 8px;">
              <button @click="getClients" class="btn btn-submit px-4">
                <i class="fe fe-filter mr-1"></i> Run Query
              </button>
              <button @click="clearFilter" class="btn btn-outline-secondary">
                <i class="fe fe-x-circle mr-1"></i> Clear
              </button>
            </div>
          </div>
        </div>

        <!-- Results -->
        <div class="card table-card shadow mb-4">
          <div class="d-flex align-items-center justify-content-between px-4 pt-4 pb-3 flex-wrap" style="gap: 8px;">
            <div class="d-flex align-items-center">
              <i class="fe fe-list text-primary mr-2"></i>
              <h6 class="mb-0 font-weight-bold">
                Total Records: <span class="text-primary">{{ clients.total | numeral(0, 0) }}</span>
              </h6>
              <span class="badge badge-soft-info ml-2">Page {{ currentPage }}</span>
            </div>
            <div class="d-flex" style="gap: 6px;">
              <button class="btn btn-sm btn-outline-secondary" @click="getPrev"><i class="fe fe-rewind"></i></button>
              <button class="btn btn-sm btn-outline-secondary" @click="getNext"><i class="fe fe-skip-forward"></i></button>
            </div>
          </div>
          <div class="card-body pt-0">
            <b-table striped hover :items="clients.data"></b-table>
          </div>
        </div>

      </div>

      <div class="vld-parent">
        <loading
          :active.sync="isLoading"
          loader="dots"
          :can-cancel="true"
          :is-full-page="fullPage"
        ></loading>
      </div>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import SearchUser from "@/views/shis/components/SearchUser.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Navbar,
    Loading,
    SearchUser,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      firstshow: false,
      secondshow: false,
      thirdshow: false,

      clients: "",
      tables: "",
      columns: "",

      table: "",
      order_by: "created_at",
      order_by_type: "desc",
      first_query_operator: "=",
      second_query_operator: "",
      third_query_operator: "",
      first_param: "",
      first_db_column: "",

      second_param: "",
      second_db_column: "",
       
       third_param: "",
      third_db_column: "",

      
      date: "",
      from: "",
      to: "",
      currentPage: 1,
      paginate: 20,
      arrayone:[
        {id:1, name: "blue", stat:"0"},
        {id:2, name: "blue", stat:"0"},
        {id:3, name: "blue", stat:"0"}
      ],
       arraytwo:[
        {id:1, name: "blue", stat:"0"},
        {id:2, name: "blue", stat:"0"},
        // {id:3, name: "blue", stat:"0"}
      ]
     
    };
  },
  beforeMount() {

    this.axios
      .get(`/api/v1/auth/db-tables`)
      .then((response) => {
        this.tables = response.data;
        console.log(response);
      

      })
      .catch((error) => {
        console.error(error);
      });
  },
  methods: {
    clearFilter() {
      this.columns = "";
      this.first_param = "";
      this.first_db_column = "";
      this.second_param = "";
      this.second_db_column = "";
      this.third_param = "";
      this.third_db_column = "";
    },
    getColumns() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/table-columns/${this.table}`)
        .then((response) => {
          this.columns = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
   
    getClients() {
      this.isLoading = true;

      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .post(`/api/v1/auth/db-query?page=${this.currentPage}`, {
            table: this.table ,
            first_db_column: this.first_db_column,
            first_param: this.first_param,
            query_order: this.query_order,
            first_query_operator: this.first_query_operator,
            second_query_operator: this.second_query_operator,
            third_query_operator: this.third_query_operator,
            second_param: this.second_param,
            second_db_column: this.second_db_column,
            third_param: this.third_param,
            third_db_column: this.third_db_column,
            order_by_type: this.order_by_type,
            order_by: this.order_by,
            paginate: this.paginate,
            
          
        })
        .then((response) => {
          this.clients = response.data;
          console.log(response);
        //   this.rows = response.data.meta.total;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;

          console.error(error);
        });
    },
    getPrev()
    {
        this.currentPage --
        this.getClients()
    },
    getNext()
    {
        this.currentPage ++
        this.getClients()
    }

  },
  created() {
   //
  },
};
</script>
